import React, { useEffect, useMemo, useState } from "react";
import Spinner from "../../Components/Loading/Spinner";
import { useDispatch, useSelector } from "react-redux";
import toast from "react-hot-toast";
import {
  CreateEventByAdmin,
  DeleteFeaturedEvent,
  GetAllFeaturedEvents,
} from "../../redux/actions/Admin/AdminActions";
import { GetUserCreatedEvents } from "../../redux/actions/Events";
import { ApiMediaURL } from "../../setting/GlobleVariable";
import { Loading } from "notiflix";
import { Plus, RefreshCw, Search, Trash2, Users, X } from "lucide-react";

const thClass =
  "text-left px-5 py-3.5 text-[10px] text-[#E52324] uppercase tracking-wider whitespace-nowrap";
const inputClass =
  "w-full px-4 py-3 rounded-xl bg-white/[0.04] border border-white/[0.08] text-white text-[14px] placeholder:text-white/25 focus:outline-none focus:ring-2 focus:ring-[#E52324]/30 focus:border-[#E52324]/40 transition-all";
const labelClass =
  "block text-[10px] text-white/40 uppercase tracking-wider mb-1.5";

function CommunityEvents() {
  const [createevent, setcreateevent] = useState(false);
  const [search, setSearch] = useState("");
  const [selectSearch, setSelectSearch] = useState("");
  const [selectedEventId, setSelectedEventId] = useState("");
  const [Paragraph, setParagraph] = useState("");
  const [event, setEvent] = useState({});
  const userCreatedEvents = useSelector((state) => state.events.userCreatedEvents);
  const isLoading = useSelector((state) => state.events.userCreatedEventsLoading);
  const FeaturedEventsdata = useSelector(
    (state) => state.Admin.featuredEvents
  )?.filter((item) => item?.isCommunity === true);

  const dispatch = useDispatch();

  const shortDescription = (text, maxLen = 30) => {
    if (!text || typeof text !== "string") return "";
    const t = text.trim();
    return t.length <= maxLen ? t : t.slice(0, maxLen) + "...";
  };

  const onlyUserCreatedEvents = (userCreatedEvents || []).filter((item) => {
    if (!item) return false;
    if (item?._isUserCreated === true || item?.isUserCreated === true) return true;
    return Boolean(item?._id) && !item?.id;
  });

  const getEventName = (item) =>
    item?.name || item?.event?.[0]?.name || "Unnamed event";

  const matchesSearch = (item, query) => {
    if (!query) return true;
    const q = query.trim().toLowerCase();
    const name = getEventName(item).toLowerCase();
    const desc = (
      item?.description ||
      item?.summary ||
      item?.notes ||
      item?.event?.[0]?.notes ||
      item?.paragarph ||
      ""
    ).toLowerCase();
    return name.includes(q) || desc.includes(q);
  };

  const filteredForSelect = useMemo(() => {
    return onlyUserCreatedEvents.filter(
      (item) => matchesSearch(item, search) && matchesSearch(item, selectSearch)
    );
  }, [onlyUserCreatedEvents, selectSearch, search]);

  const handleSelectChange = (e) => {
    const id = e.target.value;
    setSelectedEventId(id);
    const selected = onlyUserCreatedEvents.find(
      (item) => String(item.id || item._id) === String(id)
    );
    setEvent(selected || {});
  };

  const createeventFunction = () => {
    const hasEvent =
      event &&
      (event?.name || event?.event?.[0]?.name || event?._id || event?.id);
    if (!hasEvent) return toast.error("Please select an event");
    if (!event?.image) return toast.error("Selected event has no image");
    if (!Paragraph) return toast.error("Please enter the carousel paragraph");
    const formdata = new FormData();
    const url = "create/feature";
    formdata.append("event", JSON.stringify(event));
    formdata.append("paragarph", Paragraph);
    formdata.append("isCommunity", true);
    dispatch(CreateEventByAdmin(formdata, url));
    setcreateevent(false);
  };

  useEffect(() => {
    dispatch(GetAllFeaturedEvents());
    dispatch(GetUserCreatedEvents());
  }, [dispatch]);

  const adminloading = useSelector((state) => state.Admin.adminloading);
  useEffect(() => {
    if (adminloading === true) {
      Loading.standard("Loading Please Wait");
    } else {
      Loading.remove();
    }
  }, [adminloading]);

  const resetForm = () => {
    setcreateevent(false);
    setSearch("");
    setSelectSearch("");
    setSelectedEventId("");
    setParagraph("");
    setEvent({});
  };

  return (
    <div className="p-6 sm:p-8">
      <div className="w-full flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 my-2">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-xl bg-[#E52324]/15 border border-[#E52324]/20 flex items-center justify-center shrink-0">
            <Users className="w-5 h-5 text-[#E52324]" strokeWidth={2} />
          </div>
          <div>
            <h1 className="text-[22px] text-white" style={{ fontWeight: 800 }}>
              Community Events
            </h1>
            <p className="text-white/30 text-[12px] mt-1">
              Manage community spotlight events. ({FeaturedEventsdata?.length || 0} total)
            </p>
          </div>
        </div>
        <div className="flex items-center gap-2 shrink-0">
          <button
            type="button"
            onClick={() => dispatch(GetAllFeaturedEvents())}
            className="inline-flex items-center gap-2 px-4 py-2.5 rounded-xl border border-white/[0.08] text-white/50 hover:text-white hover:bg-white/[0.03] text-[12px] transition-all"
            style={{ fontWeight: 600 }}
          >
            <RefreshCw className="w-4 h-4" />
            Reload
          </button>
          <button
            type="button"
            className="inline-flex items-center gap-2 px-4 py-2.5 rounded-xl bg-[#E52324] hover:bg-[#d11f20] text-white text-[12px] transition-all shadow-lg shadow-[#E52324]/20"
            style={{ fontWeight: 600 }}
            onClick={() => setcreateevent(true)}
          >
            <Plus className="w-4 h-4" />
            Add New
          </button>
        </div>
      </div>

      <div className="my-4">
        <div className="relative overflow-x-auto bg-[#0B1120] border border-[#1a1f30] rounded-2xl">
          <table className="w-full text-sm text-left rtl:text-right text-color2">
            <thead className="bg-[#0B1120] border-b border-[#1a1f30]">
              <tr>
                <th scope="col" className={thClass}>
                  ID
                </th>
                <th scope="col" className={thClass}>
                  Image
                </th>
                <th scope="col" className={thClass}>
                  Event Name
                </th>
                <th scope="col" className={thClass}>
                  Description
                </th>
                <th scope="col" className={thClass}>
                  isCommunity
                </th>
                <th scope="col" className={thClass}>
                  Delete
                </th>
              </tr>
            </thead>
            <tbody>
              {FeaturedEventsdata &&
                FeaturedEventsdata?.map((item, index) => {
                  return (
                    <tr
                      key={item?._id || index}
                      className="border-b border-[#1a1f30]/30 last:border-b-0 hover:bg-white/[0.015] transition-colors"
                    >
                      <td className="px-5 py-3.5 text-[12px] text-blue-400 whitespace-nowrap" style={{ fontWeight: 600 }}>
                        #{item && item?._id?.slice(0, 4)}
                      </td>
                      <td className="px-5 py-3.5">
                        {item?.image ? (
                          <img
                            src={`${ApiMediaURL}/${item?.image}`}
                            alt=""
                            className="w-10 h-10 rounded-lg border border-[#1a2744] object-cover"
                          />
                        ) : (
                          <span className="text-xs text-white/25">—</span>
                        )}
                      </td>
                      <td className="px-5 py-3.5 text-[12px] text-white/80 max-w-[220px] truncate" style={{ fontWeight: 600 }}>
                        {item?.event &&
                        item?.event[0]?.name &&
                        item?.event[0]?.name?.length > 30
                          ? `${item?.event[0]?.name?.slice(0, 30)}...`
                          : item?.event[0]?.name}
                      </td>
                      <td className="px-5 py-3.5 text-[12px] text-white/40 max-w-[220px] truncate">
                        {item && item?.paragarph && item?.paragarph?.length > 30
                          ? `${item?.paragarph?.slice(0, 30)}...`
                          : item?.paragarph}
                      </td>
                      <td className="px-5 py-3.5">
                        {item && item?.isCommunity === true ? (
                          <span className="inline-flex px-2 py-0.5 rounded-full text-[9px] uppercase tracking-wider bg-emerald-500/15 text-emerald-400" style={{ fontWeight: 600 }}>
                            True
                          </span>
                        ) : (
                          <span className="inline-flex px-2 py-0.5 rounded-full text-[9px] uppercase tracking-wider bg-red-500/15 text-red-400" style={{ fontWeight: 600 }}>
                            false
                          </span>
                        )}
                      </td>
                      <td className="px-5 py-3.5">
                        <button
                          type="button"
                          className="w-9 h-9 rounded-lg flex items-center justify-center bg-red-500/10 text-red-400 hover:bg-red-500/20 transition-all"
                          onClick={() => {
                            dispatch(DeleteFeaturedEvent(item?._id));
                          }}
                        >
                          <Trash2 className="w-4 h-4" />
                        </button>
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
        </div>
      </div>

      {createevent && (
        <div className="fixed inset-0 z-[99] flex items-center justify-center p-4 bg-black/60">
          <div className="relative w-full max-w-xl max-h-[90vh] overflow-y-auto rounded-2xl bg-[#0B1120] border border-[#1a2744] shadow-xl">
            <div className="sticky top-0 z-10 flex items-center justify-between px-5 py-4 border-b border-[#1a2744] bg-[#0B1120]">
              <h3 className="text-[16px] text-white" style={{ fontWeight: 700 }}>
                New Community Event
              </h3>
              <button
                type="button"
                onClick={resetForm}
                className="p-1.5 rounded-lg text-white/40 hover:text-white hover:bg-white/[0.05] transition-all"
                aria-label="Close"
              >
                <X className="w-5 h-5" />
              </button>
            </div>

            <div className="px-5 py-5 space-y-5">
              <div className="w-[100%]">
                <label htmlFor="community-search" className={labelClass}>
                  Search Community Event By Name
                </label>
                <input
                  id="community-search"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  type="text"
                  placeholder="Please Enter Event Name"
                  className={inputClass}
                />
              </div>

              <div className="w-full mt-2">
                <label htmlFor="community-event" className={labelClass}>
                  Select Event
                </label>
                <div className="relative mb-2">
                  <Search
                    className="pointer-events-none absolute left-3.5 top-1/3 h-4 w-4 -translate-y-1/2 text-white/30"
                    strokeWidth={2}
                  />
                  <input
                    id="community-event-search"
                    value={selectSearch}
                    onChange={(e) => setSelectSearch(e.target.value)}
                    type="text"
                    placeholder="Search in list…"
                    className={`${inputClass} pl-10`}
                    autoComplete="off"
                  />
                </div>
                <select
                  id="community-event"
                  value={selectedEventId}
                  className={`${inputClass} cursor-pointer`}
                  onChange={handleSelectChange}
                >
                  <option value="" className="bg-[#0B1120]">
                    Please select an event
                  </option>
                  {isLoading ? (
                    <option value="" disabled className="bg-[#0B1120]">
                      Loading...
                    </option>
                  ) : (
                    filteredForSelect.map((item) => {
                      const desc = shortDescription(
                        item?.description || item?.summary || item?.notes || ""
                      );
                      const label = desc
                        ? `${getEventName(item)} - ${desc}`
                        : getEventName(item);
                      return (
                        <option
                          value={item?.id || item?._id}
                          key={item?.id || item?._id}
                          className="bg-[#0B1120]"
                        >
                          {label}
                        </option>
                      );
                    })
                  )}
                </select>
                {isLoading && (
                  <div className="mt-2 flex justify-center">
                    <Spinner />
                  </div>
                )}
                {!isLoading && onlyUserCreatedEvents.length > 0 && (
                  <p className="mt-2 text-[11px] text-white/30">
                    Showing {filteredForSelect.length} of {onlyUserCreatedEvents.length} events
                  </p>
                )}
              </div>

              <div className="w-[100%]">
                <label htmlFor="community-paragraph" className={labelClass}>
                  Carousal Paragraph
                </label>
                <input
                  id="community-paragraph"
                  value={Paragraph}
                  onChange={(e) => setParagraph(e.target.value)}
                  type="text"
                  placeholder="Please Enter Paragraph"
                  className={inputClass}
                />
              </div>
              {event?.image && (
                <p className="text-[11px] text-white/35">
                  Carousel will use the selected event&apos;s image
                </p>
              )}

              <button
                className="w-full py-3 rounded-xl bg-[#E52324] hover:bg-[#d11f20] text-white text-[14px] transition-colors"
                style={{ fontWeight: 700 }}
                onClick={createeventFunction}
              >
                Create
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default CommunityEvents;
